var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('toolbar',{ref:"toolbar",staticClass:"editor-toolbar",attrs:{"hidden":!_vm.editor || _vm.editor.options.plainText,"position":_vm.position,"buttons":_vm.buttons}})}
var staticRenderFns = []

export { render, staticRenderFns }